module.exports = __webpack_public_path__ + "img/57.problem_soap_dispenser.ed3c6b46.svg";